import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ThemeProvider } from "./context/ThemeContext";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import AdminLayout from "./components/admin/AdminLayout";
import AdminRequireAuth from "./components/admin/AdminRequireAuth";
import Layout from "./components/Layout";
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import AdminHomeHeroPhotosPage from "./pages/admin/AdminHomeHeroPhotosPage";
import AdminHomeHeroPhotoEditPage from "./pages/admin/AdminHomeHeroPhotoEditPage";
import AdminLatestPhotosPage from "./pages/admin/AdminLatestPhotosPage";
import AdminVideosPage from "./pages/admin/AdminVideosPage";
import AdminNewsletterSubscribersPage from "./pages/admin/AdminNewsletterSubscribersPage";
import AdminAboutSelfiesPage from "./pages/admin/AdminAboutSelfiesPage";
import AdminLoginPage from "./pages/admin/AdminLoginPage";
import { ADMIN_BASE_PATH } from "./lib/adminPaths";
import AboutPage from "./pages/AboutPage";
import ContactPage from "./pages/ContactPage";
import CvPage from "./pages/CvPage";
import HomePage from "./pages/HomePage";
import BlogPage from "./pages/BlogPage";
import BuyPage from "./pages/BuyPage";
import LicensingPage from "./pages/LicensingPage";
import NotFoundPage from "./pages/NotFoundPage";
import PhotographyPage from "./pages/PhotographyPage";
import AlbumsPage from "./pages/AlbumsPage";
import ProjectsPage from "./pages/ProjectsPage";
import StoriesPage from "./pages/StoriesPage";
import VideosPage from "./pages/VideosPage";

export default function App() {
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route
            path={ADMIN_BASE_PATH}
            element={
              <AdminAuthProvider>
                <AdminLayout />
              </AdminAuthProvider>
            }
          >
            <Route index element={<AdminLoginPage />} />
            <Route
              path="dashboard"
              element={
                <AdminRequireAuth>
                  <AdminDashboardPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/home-page-photo-show"
              element={
                <AdminRequireAuth>
                  <AdminHomeHeroPhotosPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/home-page-photo-show/:id/edit"
              element={
                <AdminRequireAuth>
                  <AdminHomeHeroPhotoEditPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/latest-photographs"
              element={
                <AdminRequireAuth>
                  <AdminLatestPhotosPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/videos"
              element={
                <AdminRequireAuth>
                  <AdminVideosPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/newsletter-subscribers"
              element={
                <AdminRequireAuth>
                  <AdminNewsletterSubscribersPage />
                </AdminRequireAuth>
              }
            />
            <Route
              path="dashboard/about-selfies"
              element={
                <AdminRequireAuth>
                  <AdminAboutSelfiesPage />
                </AdminRequireAuth>
              }
            />
            <Route path="*" element={<Navigate to={ADMIN_BASE_PATH} replace />} />
          </Route>

          <Route path="/" element={<Layout />}>
            <Route index element={<HomePage />} />
            <Route path="stories" element={<StoriesPage />} />
            <Route path="stories/:storyId/:storySlug" element={<StoriesPage />} />
            <Route path="stories/:storyId" element={<StoriesPage />} />
            <Route path="photography/showcase/:photoId/:photoSlug" element={<PhotographyPage />} />
            <Route path="photography/showcase/:photoId" element={<PhotographyPage />} />
            <Route path="photography" element={<PhotographyPage />} />
            <Route path="photography/collections/:collectionId" element={<PhotographyPage />} />
            <Route path="gallery" element={<Navigate to="/photography" replace />} />
            <Route path="videos" element={<VideosPage />} />
            <Route path="projects" element={<ProjectsPage />} />
            <Route path="projects/:projectId" element={<ProjectsPage />} />
            <Route path="blog" element={<BlogPage />} />
            <Route path="blog/:postId" element={<BlogPage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="CJJayamahas-CV" element={<CvPage />} />
            <Route path="cv" element={<Navigate to="/CJJayamahas-CV" replace />} />
            <Route path="contact" element={<ContactPage />} />
            <Route path="buy" element={<BuyPage />} />
            <Route path="licensing" element={<LicensingPage />} />
            <Route path="albums" element={<AlbumsPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
